<div class="unit-selector-list">
  <h1 [innerHtml]="'unitSelection.title' | cxTranslate"></h1>
  <span class="subtitle" [innerHtml]="'unitSelection.subtitle' | cxTranslate"></span>
  <div class="unit-body">
    @if (B2BunitLists$ | async; as response) { @if (response.b2bUnits.length == 0) {
    <div class="no-result">
      {{ 'unitSelection.noResult' | cxTranslate }}
    </div>
    } @else {
    <div class="lists">
      @for (list of response.b2bUnits; track list) {
      <div class="list">
        @if (list?.active) {
        <div>
          <app-unit-list [list]="list"></app-unit-list>
        </div>
        }
      </div>
      }
    </div>
    } }
  </div>
</div>
